import { Entry } from 'contentful';

import { TypeSpeciesSkeleton } from '@generated/contentful';

export const extractSpeciesList = (
  species: (Entry<TypeSpeciesSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'> | undefined)[],
): Entry<TypeSpeciesSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>[] => {
  const extractedSpecies = species.filter(
    (entry): entry is Entry<TypeSpeciesSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'> => !!entry,
  );
  return extractedSpecies;
};
